(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
(function () {
  var slideshowTimer = null;

  function initSlideshow() {
    if (
      typeof jQuery === "undefined" ||
      typeof jQuery.fn.slick === "undefined"
    ) {
      return;
    }

    var $slider = jQuery(".section-slideshow-v1 .slick-side-h1");

    if (!$slider.length) {
      return;
    }

    /*
     * Wait until the theme has initialized Slick.
     */
    if (!$slider.hasClass("slick-initialized")) {
      setTimeout(initSlideshow, 300);
      return;
    }

    /*
     * Stop any previous timer.
     * This prevents multiple timers from running.
     */
    if (slideshowTimer) {
      clearInterval(slideshowTimer);
      slideshowTimer = null;
    }

    /*
     * Automatically move to the next slide
     * every 3 seconds.
     */
    slideshowTimer = setInterval(function () {
      if (
        document.visibilityState === "visible" &&
        $slider.hasClass("slick-initialized")
      ) {
        $slider.slick("slickNext");
      }
    }, 3000);
  }

  /*
   * Normal page load
   */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(initSlideshow, 500);
    });
  } else {
    setTimeout(initSlideshow, 500);
  }

  /*
   * Shopify theme editor / section reload support
   */
  document.addEventListener("shopify:section:load", function () {
    setTimeout(initSlideshow, 500);
  });

  /*
   * Clean up when leaving the page.
   */
  window.addEventListener("beforeunload", function () {
    if (slideshowTimer) {
      clearInterval(slideshowTimer);
      slideshowTimer = null;
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
